export const getReferenceIdFilterList = (raw, limit = 50) => {
  if (!raw) return [];
  return String(raw)
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean)
    .slice(0, limit);
};

export const filterSelectionRowsByReferenceId = (selectionRows, referenceIdFilterList) => {
  if (!referenceIdFilterList?.length) return selectionRows;
  const wanted = new Set(referenceIdFilterList.map((value) => value.toLowerCase()));
  return (selectionRows || []).filter((row) => {
    const ref = row?.referenceId != null ? String(row.referenceId).trim().toLowerCase() : '';
    if (!ref) return false;
    return wanted.has(ref);
  });
};
